import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
type Purchase = {
  buyer: string;
  city: string;
  product: string;
  emoji: string;
};
const PURCHASES: Purchase[] = [{
  buyer: 'Soledad G.',
  city: 'Maldonado',
  product: 'Megapack Completo',
  emoji: '🏆'
}, {
  buyer: 'Valentina R.',
  city: 'Montevideo',
  product: 'Tramo 1 · Inicial',
  emoji: '📘'
}, {
  buyer: 'Lucía M.',
  city: 'Salto',
  product: 'Tramo 2 · 1° y 2°',
  emoji: '📗'
}, {
  buyer: 'Andrés P.',
  city: 'Rivera',
  product: 'Tramo 3 · 3° y 4°',
  emoji: '📙'
}, {
  buyer: 'Carolina B.',
  city: 'Canelones',
  product: 'Tramo 4 · 5° y 6°',
  emoji: '📓'
}, {
  buyer: 'Martín D.',
  city: 'Paysandú',
  product: 'Megapack Completo',
  emoji: '🏆'
}, {
  buyer: 'Florencia S.',
  city: 'Las Piedras',
  product: 'Tramo 2 · 1° y 2°',
  emoji: '📗'
}, {
  buyer: 'Gabriela T.',
  city: 'Tacuarembó',
  product: 'Megapack Completo',
  emoji: '🏆'
}];
const VISIBLE_MS = 5000;
const GAP_MS = 6000;
export function SocialProofToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (closed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    let nextTimer: ReturnType<typeof setTimeout>;
    // first appearance after a short delay
    const initialTimer = setTimeout(() => setVisible(true), 2500);
    const cycle = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        nextTimer = setTimeout(() => {
          setIndex(i => (i + 1) % PURCHASES.length);
          setMinutesAgo(Math.floor(Math.random() * 18) + 1);
          cycle();
        }, GAP_MS);
      }, VISIBLE_MS);
    };
    const startTimer = setTimeout(cycle, 2500 + VISIBLE_MS + 100);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(startTimer);
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [closed]);
  if (closed) return null;
  const p = PURCHASES[index];
  return <div className="fixed bottom-4 left-4 z-[60] max-w-[calc(100vw-2rem)] sm:max-w-xs pointer-events-none" data-id="element-139">
      <AnimatePresence data-id="element-140">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        x: -40,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -40,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 320,
        damping: 26
      }} className="pointer-events-auto bg-white rounded-2xl shadow-[0_10px_30px_rgba(13,59,110,0.18)] border border-gray-100 p-3 pr-8 relative flex items-center gap-3 w-72" data-id="element-141">
            <button type="button" aria-label="Cerrar notificación" onClick={() => setClosed(true)} className="absolute top-2 right-2 text-brand-gray hover:text-brand-text transition-colors" data-id="element-142">
              <X className="w-4 h-4" data-id="element-143" />
            </button>

            <div className="w-10 h-10 rounded-xl bg-brand-greenSoft flex items-center justify-center text-xl flex-shrink-0" data-id="element-144">
              {p.emoji}
            </div>

            <div className="min-w-0" data-id="element-145">
              <div className="flex items-center gap-1 text-[11px] font-bold text-brand-green uppercase tracking-wide" data-id="element-146">
                <CheckCircle2 className="w-3.5 h-3.5" data-id="element-147" /> Compra verificada
              </div>
              <div className="text-sm text-brand-text leading-tight mt-0.5" data-id="element-148">
                <span className="font-bold text-brand-deep" data-id="element-149">{p.buyer}</span> de{' '}
                {p.city} compró{' '}
                <span className="font-semibold text-brand-orange" data-id="element-150">
                  {p.product}
                </span>
              </div>
              <div className="text-[11px] text-brand-gray mt-0.5" data-id="element-151">
                hace {minutesAgo} minutos
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}